<ng-container *transloco="let t">
  <ng-container [ngSwitch]="messageParams?.type">
    <ng-container *ngIf="isShortenText; else fullMessage">
      <p class="truncate-text" *ngSwitchCase="'create'" [style.color]="color">
        {{
          t('system.message.created', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
            groupName: messageParams.groupName,
          }) | shortenText: 20
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'remove'" [style.color]="color">
        {{
          t('system.message.remove', {
            adminFirstName: messageParams.adminFirstName,
            adminLastName: messageParams.adminLastName,
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          }) | shortenText: 20
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'left'" [style.color]="color">
        {{
          t('system.message.left', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          }) | shortenText: 20
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'join'" [style.color]="color">
        {{
          t('system.message.joined', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          }) | shortenText: 20
        }}
      </p>
      <p
        class="truncate-text"
        *ngSwitchCase="'coachCreatedChat'"
        [style.color]="color"
      >
        {{
          t('system.message.coachCreatedChat', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
            coachFirstName: messageParams.coachFirstName,
            coachLastName: messageParams.coachLastName,
          }) | shortenText: 20
        }}
      </p>

      <p class="truncate-text" *ngSwitchCase="'newAdmin'" [style.color]="color">
        {{
          t('system.message.newAdmin', {
            newAdminFirstName: messageParams.newAdminFirstName,
            newAdminLastName: messageParams.newAdminLastName,
          }) | shortenText: 20
        }}
      </p>
    </ng-container>
    <ng-template #fullMessage>
      <p class="truncate-text" *ngSwitchCase="'create'" [style.color]="color">
        {{
          t('system.message.created', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
            groupName: messageParams.groupName,
          })
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'remove'" [style.color]="color">
        {{
          t('system.message.remove', {
            adminFirstName: messageParams.adminFirstName,
            adminLastName: messageParams.adminLastName,
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          })
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'left'" [style.color]="color">
        {{
          t('system.message.left', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          })
        }}
      </p>
      <p class="truncate-text" *ngSwitchCase="'join'" [style.color]="color">
        {{
          t('system.message.joined', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
          })
        }}
      </p>
      <p
        class="truncate-text"
        *ngSwitchCase="'coachCreatedChat'"
        [style.color]="color"
      >
        {{
          t('system.message.coachCreatedChat', {
            firstName: messageParams.firstName,
            lastName: messageParams.lastName,
            coachFirstName: messageParams.coachFirstName,
            coachLastName: messageParams.coachLastName,
          })
        }}
      </p>

      <p class="truncate-text" *ngSwitchCase="'newAdmin'" [style.color]="color">
        {{
          t('system.message.newAdmin', {
            newAdminFirstName: messageParams.newAdminFirstName,
            newAdminLastName: messageParams.newAdminLastName,
          })
        }}
      </p>
    </ng-template>
  </ng-container>
</ng-container>
